// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_CreditPurchaseSyncInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /ai/credits/admin/sync/{franquia_id} (#27, fase 1b)
 *
 * No body, no fields. The franchise is named by the URL segment, and the set
 * of charges to reconcile is READ from our own pending ai_credit_purchases
 * rows — written at checkout, before the user ever reaches the gateway. The
 * provider of each one is resolved from the platform-revenue ledger, never
 * supplied by the caller: that inference is the exact defect fase 1b removed
 * (a credit purchase was being settled with the SUBSCRIPTION's provider), and
 * letting a caller pass one would reintroduce it through the front door.
 *
 * It exists so the frontend composable can satisfy the canonical
 * `inputContract` option (same precedent as Subscriptions_AdminSweepRunInput),
 * not because there is anything to validate.
 */
import { registerContract } from './validate'

export interface AiCredits_CreditPurchaseSyncInput {}

registerContract('AiCredits_CreditPurchaseSyncInput', {})
